"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = __importDefault(require("uuid"));
var ConnectedModel_1 = require("../ConnectedModel");
var logger_1 = require("../logger");
var batchEventBus_1 = __importDefault(require("./batchEventBus"));
var helpers_1 = require("./helpers");
var response_1 = require("./helpers/response");
var getPromiseMap = new Map();
var requests = [];
exports.createCloseBatchHandler = function (adapter) {
    return function handleCloseBatch() {
        if (!requests.length) {
            logger_1.logger.info('Closed an empty batch, might be an implementation problem.');
            return;
        }
        var response = helpers_1.executeRequest(adapter, requests).catch(response_1.createGeneralErrorHandler(requests));
        response
            .then(function () { return batchEventBus_1.default.emit('batchComplete'); })
            // To satisfy ts lint
            .catch(function () { return null; });
        requests = [];
        getPromiseMap = new Map();
    };
};
var makeRequestPromise = function (request) {
    var requestId = uuid_1.default();
    requests.push(__assign({ requestId: requestId }, request));
    return new Promise(function (resolve, reject) {
        batchEventBus_1.default.once(requestId, function (response) {
            if (response.requestId) {
                response.config = request;
                response.request = {};
            }
            if (response.failureReason || !response.requestId) {
                reject(response);
            }
            else {
                resolve(response);
            }
        });
    });
};
exports.makeBatchAdapter = function (requestAdapter) {
    batchEventBus_1.default.on('closeBatch', exports.createCloseBatchHandler(requestAdapter));
    return function batchAdapter(request) {
        if (!batchEventBus_1.default.isBatchOpen) {
            return requestAdapter(request);
        }
        if (request.method === ConnectedModel_1.METHOD.GET) {
            var promise = getPromiseMap.get(request.url);
            if (!promise) {
                promise = makeRequestPromise(request);
                getPromiseMap.set(request.url, promise);
            }
            return promise;
        }
        return makeRequestPromise(request);
    };
};
exports.default = exports.makeBatchAdapter;
